import { AnimatePresence, useReducedMotion } from 'motion/react';
import * as m from 'motion/react-m';
import type { ReactNode } from 'react';

const utilitySlotSpring = {
  type: 'spring' as const,
  bounce: 0,
  visualDuration: 0.35,
};

export function useSlotTransition() {
  const prefersReducedMotion = useReducedMotion();
  return prefersReducedMotion ? { duration: 0.15 } : utilitySlotSpring;
}

export function UtilitySlot({
  isOpen,
  className,
  children,
}: {
  isOpen: boolean;
  className: string;
  children: ReactNode;
}) {
  const prefersReducedMotion = useReducedMotion();
  const transition = useSlotTransition();
  const collapsed = prefersReducedMotion
    ? { opacity: 0 }
    : { opacity: 0, flexGrow: 0 };

  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <m.div
          key='utility-selector'
          className={className}
          initial={collapsed}
          animate={{ opacity: 1, flexGrow: 1 }}
          exit={collapsed}
          transition={transition}
        >
          {children}
        </m.div>
      )}
    </AnimatePresence>
  );
}
